import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class DomiPaymentsService {
  constructor(private http: HttpClientService) {}

  public statsDomiRound(domi_date: any): Observable<any> {
    const options = { domi_date };
    return this.http
      .get("/api/domi_payments/stats/domi_round", { params: options })
      .pipe(tap((_) => console.log("DomiPaymentsService.statsDomiRound: Ok.")));
  }

  public statsDomiRoundAttempt(domi_date: any, attempt: string): Observable<any> {
    const options = { domi_date, attempt };
    return this.http
      .get("/api/domi_payments/stats/domi_round_by_attempt", { params: options })
      .pipe(tap((_) => console.log("DomiPaymentsService.statsDomiRoundAttempt: Ok.")));
  }

  public statsDomibyMonth(domi_date: any): Observable<any> {
    const options = { domi_date };
    return this.http
      .get("/api/domi_payments/stats/domi_by_month", { params: options })
      .pipe(tap((_) => console.log("DomiPaymentsService.statsDomibyMonth: Ok.")));
  }
}
